import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { makeStyles } from "tss-react/mui";
import { GetEstimatedUrgencyColor, GetSecondaryUrgencyDescription } from "../../../../common/mission";
import { useMemo } from "react";
import { TaskEnumsLists } from "../../../../common/constants";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      display: "flex"
    },
    pill: {
      width: "6px",
      borderRadius: "3px",
      height: "100%",
      marginRight: theme.spacing(1)
    }

  })
);


export default function UrgencyColumn(props) {
  const { task } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();


  const { color, title,  fromNow, description } = useMemo(() => {

    return {
      title: t(`task:enums:urgencyReason:${TaskEnumsLists.UrgencyReason[task.urgencyReason]}`),
      color: GetEstimatedUrgencyColor(task.urgency),
      fromNow: !!task.urgencyTime ? `(${task.urgencyTime?.fromNow(true)})` : null,
      description: GetSecondaryUrgencyDescription(t, task),
    }
  }, [task, t])

  return (
    <Box className={classes.root}>
      <Stack direction="row" className={classes.root}>
        <Box className={classes.pill} sx={{ background: color }}>
        </Box>
        <Stack direction="column">
          <Typography variant="body2" fontWeight={500}>{title} {fromNow}</Typography>
          <Typography variant="caption" color="textSecondary">{description}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
}